angular.module("vgresiduos").controller("mtrSystemLoginCreateCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "organizacao/integracoes/login/novo", []);
		};
	}
]);
